import React, {Component, PropTypes} from 'react';
import {Modal} from 'react-overlays';
import {inject, observer} from "mobx-react/index";

import {MODAL_NEWS_LETTER, MODAL_QUESTION_INFO, MODAL_SHARE_CALCULATION} from "../store/const";
import ModalShareCalculation from "./ModalShareCalculation";
import ModalNewsLetter from "./ModalNewsLetter";
import ModalQuestionInfo from "./ModalQuestionInfo";

// https://react-bootstrap.github.io/react-overlays/#modals

@inject("store")
@observer
export default class ModalDialog extends Component {

    constructor(props) {
        super(props);
    }

    close = () => {
        this.props.store.hideModal(false);
    };

    cancel = () => {
        this.props.store.hideModal(false);
    };

    render() {
        const modalStyle = {
            position: 'fixed',
            zIndex: 1040,
            overflow: 'auto',
            top: 0, bottom: 0, left: 0, right: 0,
        };

        const backdropStyle = {
            ...modalStyle,
            zIndex: 'auto',
            backgroundColor: '#000',
            opacity: 0.5
        };

        const {modalShown, modalType} = this.props.store;

        return (
            <Modal
                style={modalStyle}
                backdropStyle={backdropStyle}
                show={modalShown}
                onHide={this.cancel}>

                <div className="dialog-container">

                    {modalType === MODAL_SHARE_CALCULATION &&
                    <ModalShareCalculation closeModal={this.close}/>
                    }

                    {modalType === MODAL_NEWS_LETTER &&
                    <ModalNewsLetter closeModal={this.close}/>
                    }

                    {modalType === MODAL_QUESTION_INFO &&
                    <ModalQuestionInfo closeModal={this.close}/>
                    }

                </div>

            </Modal>
        );

    }
}





// WEBPACK FOOTER //
// ./src/components/ModalDialog.js